import {
  post
} from "@/plugins/request";

const prefix = '/v1/account';
// 注销
export function closeAccount(reason) {
  return post(`${prefix}/delete-account?reason=${reason}`,)
}
